import React from 'react'

const Course = ({ active = false, imageUrl, ...props }) => {
  return (
    <div
      {...props}
      className={`cursor-pointer h-20 w-20 min-h-20 max-h-20 border-2 rounded-lg ${active ? 'border-primary bg-primary-200' : 'border-grey-500 bg-white'}`}
    >
      <img
        className={`${active ? '' : 'opacity-50 grayscale'}`}
        src={imageUrl}
        alt="achievement"
      />
    </div>
  )
}

export default Course
